import { fade } from '@material-ui/core/styles/colorManipulator';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { Overrides } from '@material-ui/core/styles/overrides';

export const CheckboxOverrides = (theme: Theme): Overrides => {
  const focusOffset = '6px !important';

  return {
    MuiCheckbox: {
      // We need to use this key as opposed to root to avoid specificity issues.
      colorSecondary: {
        // Override MUI icon button min dimensions.
        minWidth: '32px',
        minHeight: '32px',

        // Set hover halo.
        width: '32px',
        height: '32px',
        padding: 0,
        borderRadius: '16px',

        // Focus ring positioning.
        '&::before': {
          borderRadius: `${theme.shape.borderRadius}px !important`,
          bottom: focusOffset,
          left: focusOffset,
          right: focusOffset,
          top: focusOffset,
        },

        '&:hover': {
          backgroundColor: fade(theme.palette.primary.main, 0.1),
        },

        '&$checked': {
          '&:hover': {
            backgroundColor: fade(theme.palette.success.main, 0.3),
          },
        },
      },
    },
  };
};
